import {Component} from '@angular/core';
import {ConversaGestorStore, EntregaGestor} from './conversa-gestor.store';

/**
 * Lateral de estado, compartilhada pelo painel e pelo simulador: em que ponto
 * da implantação a conversa está e qual modelo respondeu o último turno.
 *
 * É tela de quem opera, não do lojista — por isso mostra o código da etapa e o
 * id cru do modelo junto do rótulo em português: é esse id que aparece no log,
 * no prompt e na conta.
 */
@Component({
  selector: 'app-estado-gestor',
  templateUrl: './estado-gestor.component.html',
  styleUrls: ['./estado-gestor.component.scss'],
})
export class EstadoGestorComponent {
  constructor(public conversa: ConversaGestorStore) {}

  /** mesma regra do RoteadorDeProviders: o id diz por onde a chamada saiu */
  get provedor(): string {
    const modelo = String(this.conversa.modeloAtual || '');
    if (!modelo) return '';
    if (modelo.indexOf('/') >= 0) return 'OpenRouter';
    if (modelo.indexOf('deepseek-') === 0) return 'DeepSeek';
    if (modelo.indexOf('gemini-') === 0) return 'Google';
    if (modelo.indexOf('gpt-') === 0) return 'OpenAI';
    return 'Anthropic';
  }

  classeDaEntrega(entrega: EntregaGestor): string {
    return 'lateral__entrega--' + String(entrega.estado || 'PENDENTE').toLowerCase();
  }

  duracao(ms?: number): string {
    if (!ms && ms !== 0) return '—';
    return ms < 1000 ? `${Math.round(ms)} ms` : `${(ms / 1000).toFixed(1)} s`;
  }

  custo(usd?: number): string {
    if (!usd) return '—';
    return usd < 0.01 ? `US$ ${usd.toFixed(4)}` : `US$ ${usd.toFixed(2)}`;
  }
}
